import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './styles.scss';

// components
import SingleResult from './SingleResult';
import Loader from '../../../tools/loader/Loader';

function SearchResults(props, { t }) {
  const {
    isLoading,
    moreResultsAvailable,
    resultsCount,
    resultsShown,
    searchResults,
    updateResults,
  } = props;
  return (
    <div className="search-results">
      <div className={classNames('search-results__count', { 'search-results__count--loading': isLoading })}>
        {resultsCount > 0 ?
          <React.Fragment>
            <span>{`${resultsShown} / `}</span>
            {`${resultsCount} ${resultsCount > 1 ? t('search.results') : t('search.result')}`}
          </React.Fragment>
          :
          t('search.noResults')
        }
      </div>
      {resultsCount > 0 &&
        <div className="grid grid--with-sidebar">
          <ul className="grid__items">
            { searchResults && searchResults.map((singleResult) =>
              <SingleResult content={singleResult} key={singleResult.id} />,
            )}
          </ul>
        </div>
      }
      {!isLoading && moreResultsAvailable &&
        <button onClick={() => updateResults()} className="button button--fill search-results__button">
          {t('search.moreResults')}
        </button>
      }
      {isLoading &&
        <Loader loading={isLoading} />
      }
    </div>
  );
}

SearchResults.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  moreResultsAvailable: PropTypes.bool.isRequired,
  resultsCount: PropTypes.number.isRequired,
  resultsShown: PropTypes.number.isRequired,
  searchResults: PropTypes.array.isRequired,
  updateResults: PropTypes.func.isRequired,
};

SearchResults.contextTypes = {
  t: PropTypes.func,
};

export default SearchResults;



// WEBPACK FOOTER //
// ./src/app/components/pages/search/results/SearchResults.js